<div class="card">
  <div class="card"
    style="display: flex; justify-content: space-between; align-items: center; padding: 0; border: none; background-color: transparent;">
    <div>
      <h4><strong style=" margin-left: 10px;">Purchase Order</strong></h4>
    </div>
    <div style="display: flex; margin-top: -10px;">
      <button pButton type="button" icon="pi pi-download" (click)="onClickExcel()" style=" background-color: #2c436b;"
        label="Excel Report"></button>
      <!-- <button pButton type="button" icon="pi pi-download" (click)="downloadPDF()" style="height: 10px; margin-right: 10px; background-color: #2c436b;" label="PDF Report"></button> -->
    </div>
  </div>
  <hr>
  <div *ngIf="isContentVisible">
    <!-- <div class="flex flex-wrap gap-0">
            <div class="flex flex-wrap gap-1 mb-3">
                <div class="flex-auto">
                    <label for="integer" class="font-bold block mb-2">Company Code</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="companyCode" placeholder="Company Code"
                            pKeyFilter="alpha" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>

            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="number" class="font-bold block mb-2">Plant</label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="plant" placeholder="Plant " pKeyFilter="Plant"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Type </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docType" placeholder="Doc.Type"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="money" class="font-bold block mb-2"> Doc.Cat </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="docCat" placeholder="Doc.Cat"
                            pKeyFilter="Doc.Type" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> PO/Agreement No </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo" placeholder="PO/Agreement No"
                            pKeyFilter="PO/Agreement No" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2"> Vendor Code </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="vendorCode" placeholder="Vendor Code"
                            pKeyFilter="Vendor Code" class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphanumeric" class="font-bold block mb-2"> Status </label>
                    <div class="p-input-icon-right" style="width: calc(100% - 28px);">
                        <i class="pi pi-search" style="font-size: 12px;"></i>
                        <input pInputText id="alphabetic" [(ngModel)]="status" placeholder="Status"
                            class="w-full text-sm py-1 pl-2" />
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="hex" class="font-bold block mb-2"> Document Date </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [(ngModel)]="documentDate" [iconDisplay]="'input'" [showIcon]="true"
                            placeholder="Document Date" class="custom-calendar-filter"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphabetic" class="font-bold block mb-2 pl-5"> Valid From </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [(ngModel)]="validFromDate" [iconDisplay]="'input'" [showIcon]="true"
                            placeholder="Valid From" class="custom-calendar-filter pl-5"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2">
                <div class="flex-auto">
                    <label for="alphanumeric" class="font-bold block mb-2 pl-5"> Valid to </label>
                    <div class="p-input-icon-right">
                        <i class="pi pi-search"></i>
                        <p-calendar [(ngModel)]="validToDate" [iconDisplay]="'input'" [showIcon]="true"
                            placeholder="Valid to" class="custom-calendar-filter pl-5"
                            dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap gap-1 mb-2 pl-5 mt-2">
                <div class="flex-auto">
                    <p-button class="flex justify-content-end" icon="pi pi-search" (click)="filterData()" label="search"
                        pAutoFocus [autofocus]="true"></p-button>
                </div>
            </div>
        </div> -->

    <div class="col-12 md:col-12">
      <div class="p-formgrid grid">
        <div class="field col">
          <label>Company Code</label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="companyCode" placeholder="Company Code" pKeyFilter="alpha"
              class="w-full text-sm py-1" />
          </div>
        </div>
        <div class="field col">
          <label>Plant</label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="plant" placeholder="Plant " pKeyFilter="Plant"
              class="w-full text-sm py-1" />
          </div>
        </div>
        <div class="field col">
          <label> Doc.Type </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="docType" placeholder="Doc.Type" pKeyFilter="Doc.Type"
              class="w-full text-sm py-1 " />
          </div>
        </div>
        <div class="field col">
          <label> Doc.Cat </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="docCat" placeholder="Doc.Cat" pKeyFilter="Doc.Type"
              class="w-full text-sm py-1 " />
          </div>
        </div>
        <div class="field col">
          <label> PO/Agreement No </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="poAgreementNo" placeholder="PO/Agreement No"
              pKeyFilter="PO/Agreement No" class="w-full text-sm py-1 " />
          </div>
        </div>
        <div class="field col">
          <label> Vendor Code </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="vendorCode" placeholder="Vendor Code"
              pKeyFilter="Vendor Code" class="w-full text-sm py-1" />
          </div>
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="field col">
          <label> Status </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"></i>
            <input pInputText id="alphabetic" [(ngModel)]="status" placeholder="Status" class="w-full text-sm py-1 " />
          </div>
        </div>
        <div class="field col">
          <label> Document Date </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <p-calendar [(ngModel)]="documentDate" [iconDisplay]="'input'" [showIcon]="true" placeholder="Document Date"
              class="custom-calendar-filter" dateFormat="dd/mm/yy"></p-calendar>
          </div>
        </div>
        <div class="field col">
          <label> Valid From </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <p-calendar [(ngModel)]="validFromDate" [iconDisplay]="'input'" [showIcon]="true" placeholder="Valid From"
              class="custom-calendar-filter " dateFormat="dd/mm/yy"></p-calendar>
          </div>
        </div>
        <div class="field col">
          <label> Valid to </label>
          <div class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <p-calendar [(ngModel)]="validToDate" [iconDisplay]="'input'" [showIcon]="true" placeholder="Valid to"
              class="custom-calendar-filter" dateFormat="dd/mm/yy"></p-calendar>
          </div>
        </div>
        <!-- <div class="field col">
                    <label> </label>
                    <p-button class="flex justify-content-end" icon="pi pi-search" (click)="filterData()" label="search"
                        pAutoFocus [autofocus]="true"></p-button>
                </div> -->
        <div class="field col">
          <label> </label>
          <p-button class="flex justify-content-end" icon="pi pi-search" (click)="filterData()" label="search"
            pAutoFocus [autofocus]="true" [ngStyle]="{'height.px': '30'}"></p-button>
        </div>
        <div class="field col">
        </div>
      </div>
    </div>
  </div>

  <!-- <div style="margin-bottom: 10px;"></div>
    <div class="content-toggle-aero">
        <button (click)="toggleContentVisibility()" class="content-toggle-button">
            <i class="pi" [ngClass]="isContentVisible ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        </button>
        <div class="line"></div>
    </div>
    <div style="margin-bottom: 10px;"></div> -->

  <p-treeTable #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols" scrollHeight="400px"
    selectionMode="checkbox" [tableStyle]="{ 'min-width': '50rem','min-height':'10px' }">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem; white-space: nowrap;">Action</th>
        <th>Vendor Code</th>
        <th>PO/Agreement No</th>
        <th>Plant</th>
        <th>Document Date</th>
        <th>Name</th>
        <th>Document Type</th>
        <th>Invoice No</th>
        <th>Status</th>
        <!-- <th>Payment Status</th> -->

      </tr>
      <!-- <tr>
                <th class="text-center">Item No</th>
                <th class="text-center">Material Code</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Description </th>
                <th class="text-center">UoM</th>
                <th class="text-center">Net Value</th>
                <th class="text-center">Tax Amount</th>
                <th class="text-center">Total</th>
                <th class="text-center">Status</th>
            </tr> -->
      <!-- <tr>
                <th class="text-right">Item No</th>
                <th class="text-right">Delivery Date</th>
                <th class="text-right">Quantity</th>
                <th class="text-right">Status</th>
            </tr> -->
      <tr>
        <th></th>
        <th *ngFor="let col of cols">
          <ng-container *ngIf="col.field === 'ddate'; else textInput">
            <input pInputText type="date" (change)="onInputChange($event, col.field)" placeholder="Select date..." />
          </ng-container>
          <ng-template #textInput>
            <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" />
          </ng-template>
          <!-- <input pInputText type="text" placeholder="Search..." (input)="onInputChange($event, col.field)" /> -->
        </th>

      </tr>
    </ng-template>
    <!-- <ng-template pTemplate="caption">
            <div class="flex justify-content-end align-items-center">
                <div class="p-input-icon-left">
                    <i class="pi pi-search" style="font-size: 12px;"></i>
                    <input type="text" class="global-search" pInputText placeholder="Global Search"
                        (input)="onGlobalSearch($event)" />
                </div>
            </div>
        </ng-template> -->
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
      <tr [ttRow]="rowNode">
        <td style="width: 4rem; white-space: nowrap;">
          <ng-container *ngIf="setViewButton(rowNode)">
            <p-button icon="pi pi-eye" (click)="onClickPO(rowNode,true)" [rounded]="true"
              [style]="{ 'margin-right': '.5em' }"></p-button>
          </ng-container>
        </td>
        <td *ngFor="let col of columns; let i = index;">
          <div class="row">
            <div class="column">
              <!-- <ng-container *ngIf="setButton(rowNode)">
                                <p-button *ngIf="i === 0" [pTooltip]="tooltipContent" tooltipPosition="top"
                                    icon="pi pi-plus" (click)="showDialog(rowNode)" [rounded]="true"
                                    [style]="{ 'margin-right': '.5em' }"></p-button>
                            </ng-container> -->
              <!-- <ng-template #tooltipContent>
                                <div class="flex align-items-center">
                                    <span> <b>Add</b> Delivery Schedule! </span>
                                </div>
                            </ng-template> -->
              <!-- <ng-container *ngIf="setViewButton(rowNode)">
                                <p-button *ngIf="i === 0" tooltipPosition="top" icon="pi pi-eye"
                                    (click)="onClickPO(rowNode)" [rounded]="true"
                                    [style]="{ 'margin-right': '.5em' }"></p-button>
                            </ng-container> -->
              <!-- <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0">
                            </p-treeTableToggler> -->
            </div>
            <div *ngIf="col.field === 'status' || col.field === 'payment_status'; else defaultField">
              <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData[col.field]))">
                {{ rowData[col.field] }}
              </span>
            </div>

            <ng-template #defaultField>
              {{ rowData[col.field] }}
            </ng-template>
          </div>
        </td>
      </tr>
    </ng-template>

  </p-treeTable>
  <div>
    <p-paginator [rows]="limit" [first]="(currentPage - 1) * limit" [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)" [rowsPerPageOptions]="[10, 20,30,50,100]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
  </div>
  <p-dialog header="Header" [closable]="false" [(visible)]="visible" [modal]="true" [style]="{ width: '60rem'}"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
    <ng-template pTemplate="header">
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">Delivery Schedule</span>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-button (click)="onClose()" label="Close" pAutoFocus [autofocus]="true"></p-button>
      <p-button (click)="createDeliverySchedule()" label="Save" pAutoFocus [autofocus]="true"
        [disabled]="saveButtonDisabled || deliveryScheduleForm.invalid"></p-button>
    </ng-template>
    <form [formGroup]="deliveryScheduleForm">
      <div class="flex flex-wrap gap-3 mb-4">
        <div class="flex-auto">
          <label for="integer" class="font-bold block mb-2">PO/Item No</label>
          <p class="pl-3 pt-2 font-bold">{{poItemNo}}</p>
        </div>
        <div class="flex-auto">
          <label for="integer" class="font-bold block mb-2">Pending For Schedule Qty</label>
          <p class="pl-3 pt-2 font-bold">{{schedule_remaining_quantity}}</p>
        </div>
        <div class="flex-auto">
          <label for="number" class="font-bold block mb-2">Quantity</label>
          <p-inputNumber inputId="quantity" formControlName="quantity" [min]="0" placeholder="Quantity"
            (ngModelChange)="validateQuantity()"></p-inputNumber>
          <div *ngIf="quantityExceedsMax" class="text-red-500">Quantity cannot exceed {{ maxAllowedQuantity }}
          </div>
        </div>
        <div class="flex-auto">
          <label class="font-bold block mb-2"> Delivery Date </label>
          <div class="p-input-icon-left">
            <p-calendar formControlName="deliveryDate" [iconDisplay]="'input'" [showIcon]="true"
              placeholder="Delivery Date" appendTo="body" dateFormat="dd/mm/yy" [minDate]="correctDate"
              (ngModelChange)="dateValidationMsg()"></p-calendar>
            <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div>
          </div>
        </div>
      </div>
    </form>
  </p-dialog>
</div>


<p-dialog header="Header" [(visible)]="isZserPOVisible" [modal]="true" [style]="{ width: '85rem'}"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="font-bold white-space-nowrap">ITEM LIST</span>
    </div>
  </ng-template>
  <p-table #dt [value]="selectedPOZSERItemData" styleClass="p-datatable-sm" selectionMode="multiple">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="text-center">Item No</th>
        <th class="text-center">Service No</th>
        <th class="text-center">Short Text</th>
        <th class="text-center">Quantity</th>
        <th class="text-center">Actual Quantity</th>
        <th class="text-center">Un</th>
        <th class="text-center">Gross Price</th>
        <th class="text-center">Net Value</th>
        <th class="text-center">Currency</th>
        <th class="text-center">Tax Code</th>
        <th class="text-center">Unlimited Overfulfillment</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td class="text-center">{{rowData.data.item_no}}</td>
        <td class="text-center">{{rowData.data.service_no}}</td>
        <td class="text-center">{{rowData.data.short_text}}</td>
        <td class="text-center">{{rowData.data.quantity}}</td>
        <td class="text-center">{{rowData.data.actual_quantity}}</td>
        <td class="text-center">{{rowData.data.un}}</td>
        <td class="text-center">{{rowData.data.gross_price}}</td>
        <td class="text-center">{{rowData.data.net_value}}</td>
        <td class="text-center">{{rowData.data.currency}}</td>
        <td class="text-center">{{rowData.data.tax_code}}</td>
        <td class="text-center">{{rowData.data.unlimited_overfulfillment}}</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<p-sidebar [(visible)]="sidebarVisible" position="right" [style]="{'width': '75%'}">
  <div class="grid">
    <div class="col-10">
      <h5><strong>{{"PO/Agreement No : "+ po_no}}</strong></h5>
    </div>
    <div class="col-2">
      <div class="button-container">
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="downloadExcel()"
          class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
      </div>
    </div>
  </div>

  <p-table #dt [value]="selectedPOData" styleClass="p-datatable-sm" selectionMode="multiple">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>Vendor Code</th>
        <th>PO/Agreement No</th>
        <th>Plant</th>
        <th>Document Date</th>
        <th>Name</th>
        <th>Document Type</th>
        <th>Status</th>
        <!-- <th>Payment Status</th> -->
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td>{{rowData.vcode}}</td>
        <td>{{rowData.pono}}</td>
        <td>{{rowData.plant}}</td>
        <td>{{rowData.ddate}}</td>
        <td>{{rowData.name}}</td>
        <td>{{rowData.docType}}</td>
        <!-- <td>{{rowData.status}}</td> -->
        <td>
          <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.status))">
            {{ rowData.status }}
          </span>
        </td>
        <!-- <td>
                    <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.payment_status))">
                        {{ rowData.payment_status }}
                    </span>
                </td> -->
      </tr>
    </ng-template>
  </p-table>
  <h5><strong>Item List</strong></h5><br>
  <p-table #dt [value]="selectedPOItemData" styleClass="p-datatable-sm" selectionMode="multiple"> <ng-template
      pTemplate="header" let-columns>
      <tr>

        <th>Action</th>
        <th *ngIf="!isZserPO"></th>
        <th>Item No</th>
        <th>Material Code</th>
        <th>Material Description</th>
        <th>Quantity</th>
        <th>Pending Quantity</th>
        <th>UoM</th>
        <th>Unit Price</th>
        <th>Per</th>
        <th>Currency</th>
        <th>Net Value</th>
        <th>Tax Amount</th>
        <th>Total Value</th>
        <!-- <th *ngIf="isZserPO">Overall Limit</th>
        <th *ngIf="isZserPO">Expected Value</th> -->
        <th *ngIf="isZserPO">Actual Value</th>
        <th>Status</th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngIf="!isZserPO"><p-button icon="pi pi-eye" [rounded]="true" (click)="showScheduleDelivery(rowData)"
            [style]="{ 'margin-right': '.5em' }"></p-button></td>
        <td><p-button icon="pi pi-plus" (click)="showDialog(rowData)" [rounded]="true"
            [style]="{ 'margin-right': '.5em' }"></p-button></td>
        <td>{{rowData.pono}}</td>
        <td>{{rowData.ddate}}</td>
        <td>{{rowData.name}}</td>
        <td>{{rowData.vcode}}</td>
        <td>{{rowData.availableQty}}</td>
        <td>{{rowData.status}}</td>
        <td>{{rowData.unit_price}}</td>
        <td>{{rowData.per}}</td>
        <td>{{rowData.currency}}</td>
        <td>{{rowData.a1}}</td>
        <td>{{rowData.b1}}</td>
        <td>{{rowData.c1}}</td>
        <!-- <td *ngIf="isZserPO">{{rowData.overall_limit}}</td>
        <td *ngIf="isZserPO">{{rowData.expected_value}}</td> -->
        <td *ngIf="isZserPO">{{rowData.actual_value}}</td>
        <!-- <td>{{rowData.d1}}</td> -->
        <td>
          <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.d1))">
            {{ rowData.d1 }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="!isZserPO">
    <h5><strong>Schedule List</strong></h5><br>
    <p-table #dt [value]="selectedPOScheduleData" styleClass="p-datatable-sm" selectionMode="multiple"> <ng-template
        pTemplate="header" let-columns>
        <tr>
          <th>Item No</th>
          <th>Delivery Date</th>
          <th>Quantity</th>
          <th>Actual Quantity</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>{{rowData.pono}}</td>
          <td>{{rowData.ddate}}</td>
          <td>{{rowData.vcode}}</td>
          <td>{{rowData.status}}</td>
          <td>
            <span class="custom-tag" [ngClass]="getSeverityClass(getSeverity(rowData.name))">
              {{ rowData.name }}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-sidebar>

<p-dialog header="Header" [closable]="true" [(visible)]="visible1" [modal]="true" [style]="{ width: '50rem'}">
  <ng-template pTemplate="header">
    <div class="inline-flex align-items-center justify-content-center gap-2">
      <span class="font-bold white-space-nowrap">Delivery Schedule</span>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <div>
      <p-table #dt [value]="selectedPOScheduleData2" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '40rem' }"
        selectionMode="multiple">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>Item No</th>
            <th>Delivery Date</th>
            <th>Quantity</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{rowData.pono}}</td>
            <td>{{rowData.ddate}}</td>
            <td>{{rowData.vcode}}</td>
            <td>{{rowData.name}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>
</p-dialog>

<p-dialog header="Header" [closable]="false" [(visible)]="isExcel" [modal]="true" [style]="{ width: '35rem'}"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="header">
    <!-- <div class="inline-flex align-items-center justify-content-center gap-2">
        <span class="font-bold white-space-nowrap">Select Date</span>
    </div> -->
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (click)="onCloseForExcelReport()" label="Close" pAutoFocus [autofocus]="true"></p-button>
    <p-button (click)="onDowunloadPoListByDate()" label="Download" pAutoFocus [autofocus]="true"
      [disabled]="!startDate || !endDate || dateValidation1"></p-button>
  </ng-template>
  <div class="grid">
    <div class="col">
      <label class="font-bold block mb-2"><strong>Start Date</strong><span class="required-asterisk">*</span></label>
      <div class="p-input-icon-left">
        <p-calendar [iconDisplay]="'input'" [showIcon]="true" placeholder="Select Date" [(ngModel)]="startDate"
          appendTo="body" dateFormat="dd/mm/yy" [maxDate]="correctDate" [showButtonBar]="true"
          (onSelect)="validateDate()" [required]="true"></p-calendar>
      </div>
    </div>
    <div class="col">
      <label class="font-bold block mb-2"><strong>End Date</strong><span class="required-asterisk">*</span></label>
      <div class="p-input-icon-left">
        <p-calendar [iconDisplay]="'input'" [showIcon]="true" placeholder="Select Date" appendTo="body"
          [(ngModel)]="endDate" dateFormat="dd/mm/yy" [maxDate]="correctDate" [showButtonBar]="true"
          (onSelect)="validateDate()" [required]="true"></p-calendar>
        <!-- <div *ngIf="dateValidation" class="text-red-500">Please select correct date</div> -->
        <div *ngIf="endDate && startDate && endDate < startDate" class="text-red-500">End date cannot be before start
          date.</div>
        <div *ngIf="dateValidation1 && endDate && getDateDifference() > 12" class="text-red-500">The end date cannot be
          more than 1 Year after the start date.</div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <label><strong>PO/Agreement No</strong></label>
      <input pInputText [(ngModel)]="poAgreementNos" style="width: 100%;" />
    </div>
  </div>
  <div class="grid" *ngIf="plantList.length > 1">
    <!-- <div class="col">
        <label><strong>Plant</strong></label>
        <input pInputText [(ngModel)]="plants" style="width: 100%;" />
      </div> -->
    <div class="col">
      <label><strong>Select Plant</strong></label>
      <p-multiSelect [options]="plantList" [(ngModel)]="plants" optionLabel="name1" optionValue="plant__code"
        [style]='{"width":"100%"}' appendTo="body" placeholder="Select Plant" />
    </div>
  </div>
  <div class="grid" *ngIf="!isVendor">
    <div class="col">
      <label><strong>Vendor Code</strong></label>
      <input pInputText [(ngModel)]="vendorNames" style="width: 100%;" />
    </div>
  </div>
</p-dialog>


<div *ngIf="isLoading" class="loading-overlay">
  <app-loading-screen></app-loading-screen>
</div>

<p-toast></p-toast>
